import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/voucher/banners?${stringify(params)}`);
}



export async function get(id, params = {}) {
  if (params) {
    return request(`/voucher/banners/${id}?${stringify(params)}`);
  }
  return request(`/voucher/banners/${id}`);
}

export async function create(body) {
  return request(`/voucher/banners`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/voucher/banners/${id}`, {
    method: 'POST',
    body,
  });
}